import { YoutubeService } from "../../page-services/youtube-service";
import * as $ from 'jquery';

export class AccordionCommon {


    static initAll() {
        $('.accordion-component .accordion').each((i, acc) => {
            AccordionCommon.initCommon($(acc));
        })
    }

    static initCommon(accordion) {
        accordion.find('.non-editable-root .card').each((i, element) => {
            const card = $(element);
            card.parent().addClass('card').html(card.html());
        });
        accordion.find('.collapse').attr('data-parent', `#${accordion.attr('id')}`);
        accordion.find('.collapse')
            .collapse({ toggle: false })
            .on('shown.bs.collapse', ev => {
                if ($(ev.target).find('.youtube-video').length > 0) {
                    YoutubeService.updateLayout();
                }
                $(ev.target).closest('.accordion-item').addClass('opened-item')
            })
            .on('hidden.bs.collapse', ev => {
                $(ev.target).closest('.accordion-item').removeClass('opened-item')
            });
        let child = accordion.find('.card-body .block div > :first-child');
        let height = child.outerHeight(true) + 20;
        height = height + 'px';
        accordion.find('.collapse').css('height',height);
        accordion.find('.collapse').css('min-height',height);

    }
}